import EventEmitter from "./event_emitter"

/**
 * @extends {EventEmitter}
 */
class EndScreenContainer extends EventEmitter {
  /**
   * @param {!EndScreenContainer.Renderer} renderer
   * @param {string} rootElementId
   */
  constructor(renderer, rootElementId = 'player-container') {
    super()

    /** @private {!EndScreenContainer.Renderer} */
    this._renderer = renderer ? renderer : new EndScreenContainer.Renderer()

    /** @private {!HTMLElement} */
    this._rootElement = document.getElementById(rootElementId)

    /** @private {HTMLElement} */
    this._container = null

    /** @private {boolean} */
    this._isHidden = false

    window.addEventListener('resize', () => this.reload())
  }

  get rootElement() {
    return this._rootElement
  }

  get container() {
    return this._container
  }

  get isHidden() {
    return this._isHidden
  }

  load() {
    this._container = this._renderer.willInsertContainerElement(this)
    this._rootElement.appendChild(this._container)
    this._renderer.didInsertContainerElement(this)
    this._renderer.render(this, this._rootElement.dataset)
  }

  reload() {
    if (!this._isHidden && this._container) {
      this._container.remove()
      this._container = null
      this.load()
    }
  }

  show() {
    if (this._container) {
      this._isHidden = false
      this._container.classList.remove('is-hidden')
      this.reload();
    }
  }

  hidden() {
    if (this._container) {
      this._isHidden = true
      this._container.classList.add('is-hidden')
    }
  }
}

EndScreenContainer.Renderer = class {
  constructor() {
  }

  /**
   * @param {EndScreenContainer} endScreenContainer
   * @returns {HTMLElement}
   */
  willInsertContainerElement(endScreenContainer) {
    // override this
    return document.createElement('div')
  }

  /**
   * @param {EndScreenContainer} endScreenContainer
   */
  didInsertContainerElement(endScreenContainer) {
    // override this
  }

  /**
   * @param {EndScreenContainer} endScreenContainer
   * @param {Object} data
   */
  render(endScreenContainer, data) {
    // override this
  }
}

export default EndScreenContainer
